import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./JobDetailTab.module.css";
/** Compact badge matching Change Tradesperson warning style - for use in card title rows. */
export const ActionRequiredBadge = ({ onViewDetails, }) => (_jsxs("span", { className: styles.titleWarning, children: [_jsx("span", { className: styles.warningIcon, children: "warning" }), _jsx("span", { className: styles.warningText, children: "Action Required" }), onViewDetails && (_jsx("button", { type: "button", className: styles.viewDetailsBadgeBtn, onClick: (e) => {
                e.stopPropagation();
                onViewDetails();
            }, children: "View Details" }))] }));
